export default "__VITE_ASSET__DhoXPiZg__"